import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    height: 50,
    width: '100%',
    borderRadius: 8,
    textTransform: 'capitalize',
  },
}));

export default useStyles;
